import { motion } from "framer-motion";
import { LogOut, KeyRound, Store, CloudDownload } from "lucide-react";

const STEPS = [
  {
    key: "sign-out",
    icon: LogOut,
    title: "Выйдите из своего Apple ID",
    desc: "В настройках Apple ID нажмите «Выйти». Выберите «Выйти, но не стирать данные», затем нажмите «Продолжить».",
    caption: "Выйдите из аккаунта без стирания данных",
    screenshot: "/assets/prosto-guide/step-1-sign-out.png",
  },
  {
    key: "sign-in",
    icon: KeyRound,
    title: "Войдите с выданными данными",
    desc: "Откройте «Аккаунт Apple», выберите «Войти вручную» и используйте выданные данные в соответствии с инструкцией.",
    caption: "«Аккаунт Apple» → «Войти вручную»",
    screenshot: "/assets/prosto-guide/step-2-sign-in.png",
  },
  {
    key: "icloud-install",
    icon: Store,
    title: "Откройте iCloud",
    desc: "Перейдите в iCloud и подтвердите установку приложения кнопкой «Установить».",
    caption: "Откройте iCloud и нажмите «Установить»",
    screenshot: "/assets/prosto-guide/step-3-icloud-install.png",
  },
  {
    key: "download",
    icon: CloudDownload,
    title: "Завершите установку и вернитесь в свой аккаунт",
    desc: "Нажмите на значок облака рядом с нужным приложением и дождитесь завершения загрузки. После установки выйдите из общего Apple Account через настройки iCloud и снова войдите в свой личный аккаунт.",
    caption: "Установите нужные приложения и вернитесь в свой личный аккаунт",
    screenshot: "/assets/prosto-guide/step-4-complete.png",
  },
];

function ScreenshotFrame({ src, caption }) {
  return (
    <div className="mx-auto w-full max-w-[560px]">
      <div className="relative w-full">
        <img src={src} alt={caption} loading="lazy" className="block h-auto w-full object-contain" />
      </div>
      <p className="px-2 pb-2 pt-2 text-center text-xs leading-relaxed text-slate-500">{caption}</p>
    </div>
  );
}

export default function ProstoInstallGuide() {
  return (
    <div className="space-y-3" data-testid="prosto-install-guide">
      {STEPS.map((step, i) => {
        const Icon = step.icon;
        return (
          <motion.article
            key={step.key}
            data-testid={`prosto-install-step-${i + 1}`}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-32px" }}
            transition={{ duration: 0.3, delay: i * 0.03 }}
            className="rounded-3xl border border-slate-200 bg-white p-3 shadow-sm"
          >
            <div className="flex items-start gap-3">
              <span className="grid h-9 w-9 shrink-0 place-items-center rounded-2xl bg-blue-50 font-display text-base font-extrabold text-[#2F6BFF]">{i + 1}</span>
              <div className="min-w-0 pt-0.5">
                <h3 className="flex items-center gap-2 font-display text-[15px] font-extrabold leading-snug text-slate-900"><Icon size={16} className="shrink-0 text-[#2F6BFF]" />{step.title}</h3>
                <p className="mt-1.5 text-[13px] leading-relaxed text-slate-600">{step.desc}</p>
              </div>
            </div>
            <div className="mt-3 -mx-3 overflow-hidden rounded-xl border border-slate-200 bg-white">
              <ScreenshotFrame src={step.screenshot} caption={step.caption} />
            </div>
          </motion.article>
        );
      })}
    </div>
  );
}
